import React, { useEffect, useState } from "react";
import { AppHelper } from '../../AppHelper';
import {
  Button, Box, Dialog, DialogTitle, CircularProgress
} from '@mui/material';
import dayjs from "dayjs";
const relativeTime = require("dayjs/plugin/relativeTime");
dayjs.extend(relativeTime);

export default function PopScanAgain ({
  onCancel, open, onStart
}){
  const [isLoading, setIsLoading] = useState(false);
  
  useEffect(()=>{
    if(!open) return;
    setIsLoading(false);
  }, [open]);
  const handleClose = () =>{ onCancel() };
  const handleStart = () =>{ 
    onStart();
    setIsLoading(true);
  };
  return(
    <>
    <Dialog onClose={handleClose} open={open} sx={{minWidth:'400px'}}>
      <DialogTitle>Try Enhanced Transcription</DialogTitle>
      <Box padding={'0.5rem'} textAlign={'center'}>
        The transcription may not be accurate due to unclear handwriting. Would you like to try an enhanced transcription method for better results?  
      </Box>
      { !isLoading &&
      <Box padding={'0.5rem'} textAlign={'center'}>
        <Button onClick={handleStart} className="app-btn-bg" color="info" variant="contained" size="large" style={{marginRight:'2px'}}>Proceed</Button>
        <Button onClick={handleClose} color="info" variant="text" size="large" style={{marginRight:'2px'}}>Cancel</Button>
      </Box>
      }
      { isLoading &&
        <div style={{margin:'1rem', textAlign:'center'}}>
          <CircularProgress />
        </div>
      }
    </Dialog>
    </>
  );
}